import {
    createObjectField,
    createPrimitiveField,
    type InferFieldValue,
    type ValidationError,
} from '@adv-frontend/form-kit';

export const fieldCourierAddress = createObjectField({
    fields: {
        locality: createPrimitiveField({ defaultValue: '' }),
        address: createPrimitiveField({ defaultValue: '' }),
        floor: createPrimitiveField({ defaultValue: '' }),
        appartment: createPrimitiveField({ defaultValue: '' }),
        entrance: createPrimitiveField({ defaultValue: '' }),
        intercom: createPrimitiveField({ defaultValue: '' }),
        comment: createPrimitiveField({ defaultValue: '' }),
    },
    validators: (createValidators) =>
        createValidators<
            ValidationError<'REQUIRED_DELIVERY_ADDRESS' | 'REQUIRED_DELIVERY_FLOOR' | 'UNSUPPORTED_ADDRESS'>
        >(),
});

export type CourierAddressFieldValue = InferFieldValue<typeof fieldCourierAddress>;
